import { createContext } from 'react';
import { IFileData, ICreateApk, TApkType, TParametersOfApkType } from 'types';

export type TTypeOfCreateApkModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';

export interface ICreateApkState {
	versionName: string;
	versionCode: string;
	description: string;
	applicationId: string;
	parameterOfApkType: Nullable<TParametersOfApkType>;
	IDSelectedApkType: Nullable<TApkType>;
	isCutoverBeforeUpdate: boolean;
	fileData: IFileData;
	dataForSubmit: ICreateApk | null;
	typeOfModalWindow: TTypeOfCreateApkModalWindow;
}

export const createApkInitialState: ICreateApkState = {
	versionName: '',
	versionCode: '',
	description: '',
	applicationId: '',
	parameterOfApkType: null,
	IDSelectedApkType: null,
	isCutoverBeforeUpdate: false,
	fileData: {
		fileId: '',
		fileHash: null,
		fileName: null,
	},
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface ICreateApkContext extends ICreateApkState {
	changeVersionName(value: string): void;
	changeVersionCode(value: string): void;
	changeDescription(value: string): void;
	changeApplicationId(value: string): void;
	setParameterOfApkType(value: Nullable<TParametersOfApkType>): void;
	setIDApkType(value: Nullable<TApkType>): void;
	toggleCutoverBeforeUpdate(): void;
	changeFileData(value: IFileData): void;
	setDataForSubmit(value: ICreateApk | null): void;
	changeTypeOfModalWindow(value: TTypeOfCreateApkModalWindow): void;
	resetFields(): void;
}

export const CreateApkContext = createContext<ICreateApkContext>({
	changeVersionName: () => undefined,
	changeVersionCode: () => undefined,
	changeDescription: () => undefined,
	changeApplicationId: () => undefined,
	setParameterOfApkType: () => undefined,
	setIDApkType: () => undefined,
	toggleCutoverBeforeUpdate: () => undefined,
	changeFileData: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...createApkInitialState,
});
